<div class="min-h-full bg-secondary-100 pb-navigation overflow-hidden h-full-minus-navigation-height">
  <div class="overflow-auto max-h-full mt-header-border-radius h-full-minus-header-border-radius">
    <app-container>
      <div class="py-4 font-primary">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-y-7 lg:gap-x-7">
          <div class="col-span-2">
            <div class="max-w-2xl">
              <h1 class="hidden lg:block font-secondary text-4xl font-bold">
                Download de app!
              </h1>
              <p class="mt-4">
                Met de app 'Op Goeie Grond' heb je alle hotspots van gemeente Peel en Maas altijd binnen handbereik.
                <br>
                Download de app, plan je volgende avontuur en krijg toegang tot exclusieve verhalen en geheime tips van
                lokale bewoners!
              </p>
              <div class="mt-8 flex items-center gap-2">
                <a href="https://apps.apple.com/nl/app/op-goeie-grond/id6740774229" target="_blank">
                  <img ngSrc="/images/custom/download-in-the-app-store.svg" alt="Download in de App Store" height="60"
                       width="180">
                </a>
                <a href="https://play.google.com/store/apps/details?id=nl.inova.opgoeiegrond" target="_blank">
                  <img ngSrc="/images/custom/download-in-the-play-store.png" alt="Download in de Play Store" height="53"
                       width="180">
                </a>
              </div>
            </div>
          </div>
          <div class="">
            <img [ngSrc]="'/images/custom/download-app-info-banner.png'" class="mx-auto"
                 alt="Download de Genieten Op Goeie Grond app" priority
                 height="491" width="571">
          </div>
        </div>
      </div>
    </app-container>
  </div>
</div>
